import script from "./LandingFeaturesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingFeaturesSection.vue?vue&type=script&setup=true&lang=js"

import "./LandingFeaturesSection.vue?vue&type=style&index=0&id=867bd0d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-867bd0d0"]])

export default __exports__